import { FC, useEffect, useRef } from 'react'
import { BottomSheet as BaseBottomSheet, BottomSheetProps } from 'react-components'

// react-components' BottomSheet renders react-modal directly (not through our own Modal wrapper),
// and delays removing its body-scroll-lock class by `closeTimeoutMS` (300ms) to let the close
// animation finish. If the sheet is dismissed again (or the page navigates) before that timer
// fires, the cleanup never runs and the page is left permanently unable to scroll. This wrapper is
// a safety net: shortly after the sheet reports closed/unmounted, force the lock off regardless of
// what react-modal's own bookkeeping did.
const BODY_OPEN_CLASS = 'ReactModal__Body--open'
const SAFETY_NET_DELAY_MS = 400

const releaseBodyScrollLock = (): void => {
    document.body.classList.remove(BODY_OPEN_CLASS)
    document.body.style.overflow = ''
}

const BottomSheet: FC<BottomSheetProps> = props => {
    const { isOpen } = props
    const wasOpenRef = useRef(isOpen)

    useEffect(() => {
        if (wasOpenRef.current && !isOpen) {
            const timer = setTimeout(releaseBodyScrollLock, SAFETY_NET_DELAY_MS)
            wasOpenRef.current = isOpen
            return () => clearTimeout(timer)
        }
        wasOpenRef.current = isOpen
        return
    }, [isOpen])

    useEffect(() => {
        return () => {
            if (wasOpenRef.current) {
                releaseBodyScrollLock()
            }
        }
    }, [])

    return <BaseBottomSheet {...props} />
}

export default BottomSheet
